export const ConnectionsBaseQA = {
    S3_ACTION_BUTTON: 'conn-s3-action-btn',
    S3_UPLOAD_BUTTON: 'conn-s3-upload-btn',
    SUBMIT_ACTION_BUTTON: 'conn-submit-action-btn',
};

export const ConnectionsWorkspaceQA = {
    WORKSPACE: 'conn-workspace',
};

export const ConnectionsFormQA = {
    AUTO_CREATE_DASH_CHECKBOX: 'conn-auto-create-dash-checkbox',
    CREATE_CHYT_TOKEN_AUTH_NAV: 'conn-create-token-auth-nav',
    CREATE_CHYT_USER_AUTH_NAV: 'conn-create-user-auth-nav',
};

export const ConnectionsActionPanelControls = {
    CREATE_QL_CHART_BUTTON: 'conn-action-panel-controls-create-ql-chart-button',
};

export const ConnectionsS3BaseQA = {
    LIST_ITEM: 'conn-s3-list-item',
    LIST_ITEM_ACTION_MORE: 'conn-s3-list-item-action-more',
    LIST_ITEM_ACTION_MORE_DELETE: 'conn-s3-list-item-action-more-delete',
    LIST_ITEM_ACTION_MORE_RENAME: 'conn-s3-list-item-action-more-rename',
    LIST_ITEM_ACTION_MORE_REPLACE: 'conn-s3-list-item-action-more-replace',
    S3_SOURCE_DIALOG_BATCH_CHECKBOX: 'conn-s3-source-dialog-batch-checkbox',
    S3_SOURCE_DIALOG_LIST_ITEM: 'conn-s3-source-dialog-list-item',
    S3_SOURCE_DIALOG_SUBMIT_BUTTON: 'conn-s3-source-dialog-submit-button',
};

export const ConnectionsYadocsQA = {
    ADD_DOCUMENT_BUTTON: 'conn-yadocs-add-document-button',
    ADD_DOCUMENT_DIALOG_INPUT: 'conn-yadocs-add-document-dialog-input',
    ADD_DOCUMENT_DIALOG_SUBMIT_BUTTON: 'conn-yadocs-add-document-dialog-submit-button',
    LIST_SECTION: 'conn-yadocs-list-section',
};
